module.exports = __webpack_public_path__ + "static/media/logo.e7ac0e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LoginPage/logo.png
// module id = 1042
// module chunks = 0